import Settings from 'containers/settings/Settings';
import { FC } from 'react';

const SettingsPage: FC = () => {
  return <Settings />;
};

export default SettingsPage;
